<div class="dropdown ms-1 ms-lg-3 topbar-head-dropdown fw-bold fs-14" role='button'>
  <!-- <button type="button" class="btn btn-icon btn-topbar btn-ghost-primary rounded-circle arrow-none" data-bs-toggle="dropdown"
  aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
  <img *ngIf="flagvalue !== undefined" src="{{flagvalue}}" alt="Header Language" class="rounded" height="20">
  <img *ngIf="flagvalue === undefined" src="{{valueSet}}" alt="Header Language" class="rounded" height="20">
</button>
<div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
  <a href="javascript:void(0);" class="dropdown-item notify-item language py-2" data-lang="eng"
    *ngFor="let item of listLang" (click)="setLanguage(item)" [class.active]="cookieValue === item.lang">
    <img src="{{item.flag}}" alt="user-image" class="me-2 rounded" height="18"> <span
  class="align-middle">{{item.text}}</span>
</a>
</div> -->
  @if (this.cookieValue == 'ar') {
  <span (click)="setLanguage('en')">English</span>
  }
  @if (this.cookieValue == 'en') {
  <span (click)="setLanguage('ar')">العربية</span>
  }
</div>